import { render } from "./Basic.vue?vue&type=template&id=3eb5a3ae"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"
script.render = render

export default script